import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import ChecklistPage from "../checklist/ChecklistPage";

export default function AdminChecklistPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <AdminNavbar />
      <ChecklistPage />
    </div>
  );
}
